/** @jsx jsx */
// External libraries
import { jsx } from '@emotion/core';
import { appStore } from '@/store';
import { getContent } from '@/lib';
import { string } from 'prop-types';

//  Internal modules
import { getTermsLinks } from './Components';
import { useMountLogging } from '@/lib/reactHooks';
import { getBillingAgreementKey, mapBillingFlowToContentKey } from './utils';
import { textStyles } from './styles';
import { StyledText } from '@/components/Common';

const BillingTerms = ({ type }) => {
  const { api } = appStore.getState();
  const merchantName =
    api.cartDetails.merchant.name || getContent('base.theMerchant');
  useMountLogging(`${type}BillingTerms`);
  //generating appropriate billingAgreement keys for the correct legal text
  const flowType = mapBillingFlowToContentKey(type);
  const billingAgreementKey = getBillingAgreementKey(flowType);
  const termsLinks = getTermsLinks(billingAgreementKey);
  termsLinks.merchantName = <b>{merchantName}</b>;

  return (
    <StyledText css={textStyles}>
      {getContent(billingAgreementKey, termsLinks)}
    </StyledText>
  );
};

BillingTerms.propTypes = {
  type: string.isRequired,
};

export { BillingTerms };
